import React, { useEffect, useState } from "react";
import {
  Button,
  Breadcrumb,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  Row,
  Stack,
  FormSelect,
  InputGroup,
  Modal,
} from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";

import PubSub from "pubsub-js";
import Select from "react-select";
import moment from "moment";
import { regExPattern } from "../../utils/regExPattern";
import { validationMessages } from "../../utils/messages";
import { ROUTES } from "../../constants/webRouting";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import * as Constant from "../../constants/CONSTANT";
import CityState from "../../constants/CityState.json";
import { formatDate, getUserDetails, formatDateForCreatedDate, } from "../../utils/helper";
import helper from "../common/Permissionhelper";
import { handleUppercaseChange } from "../common/UpperCaseMethod";
import PERMISSIONS from "../../constants/permissions";
import * as constants from "../../constants/CONSTANT"; ////Added by shahir hussain 02-02-2025

const OfferEdit = () => {
  const userInfo = getUserDetails();
  const location = useLocation();
  const navigate = useNavigate();
  //Imran Khan 27/01/2026 Elevator Modal State
  // const [showElevatorModal, setShowElevatorModal] = useState(false);
  // const [elevatorDraft, setElevatorDraft] = useState({
  //   type: "",
  //   capacity: null,
  //   unit: ""
  // });
  //End Here Imran Khan 27/01/2026 Elevator Modal State

  // Define initial errors i.e. required field and their message
  const initialErrors = {
    lead_id: { message: validationMessages.leadName.required },
    offer_name: { message: validationMessages.offerName.required },
    offer_status: { message: validationMessages.status.required },
    phone: { message: validationMessages.phone.required },
    owner_ids: { message: validationMessages.ownerIds.required },
    highest_model_rate: {
      message: validationMessages.highestModelRate.required,
    },
    number_of_units: { message: validationMessages.numberOfUnits.required },
    // area: { message: validationMessages.area.required },//Added by shahir hussain 28-01-2026
  };
  //Added Imran Khan 15/01/2026 number of units
  const initialValues = {
    offer_date: new Date(),
    owner_ids: [{ value: userInfo?.id, label: userInfo?.username }],
    is_gst: "Yes",
    city: "Jaipur",
    number_of_units: location.state?.qty || 1,
  };

  // offer state
  const [offer, setOffer] = useState(
    location.state ? location.state : initialValues,
  );

  //Imran Khan 20/01/2026
  const [lostData, setLostData] = useState({
    is_lost_date: offer?.is_lost_date || new Date(),
    is_lost_remark: "",
    lost_by_reason: "",
  });
  //End Here Imran Khan 20/01/2026

  //Door Opening Side Selection State Imran Khan 28/01/2026
  const isSideSelected =
    offer?.door_opening === "SIDE" || offer?.door_opening?.startsWith("SIDE_");

  const sideValues = offer?.door_opening?.includes("SIDE_")
    ? offer.door_opening.split(",").filter((v) => v.startsWith("SIDE_"))
    : [];
  //End Here Door Opening Side Selection State Imran Khan 28/01/2026

  //Imran Khan 27/01/2026 Elevator Capacity Options
  // const getCapacityOptions = (type) => {
  //   if (type === "Passenger")
  //     return { list: [4,6,8,10,13,16,20], unit: "Passenger" };

  //   if (type === "Hospital")
  //     return {
  //       list: [15,20,26],
  //       unitMap: {
  //         15: "Passenger cum Stretcher",
  //         20: "Passenger cum Bed",
  //         26: "Passenger cum Bed"
  //       }
  //     };

  //   if (type === "Goods")
  //     return { list: [500,1000,1500,2000,2500,3000,4000,5000], unit: "Kg" };

  //   if (type === "Dumbwaiter")
  //     return { list: [100,150,200,250,500], unit: "Kg" };

  //   return { list: [] };
  // };
  //End Here Imran Khan 27/01/2026 Elevator Capacity Options

  //Imran Khan 28/01/2026 Civil Requirements Options
  const civilRequirements = {
    Vacuum: {
      pit: [{ value: "NO_PIT", label: "No pit required" }],
      overhead: ["2600", "2700", "2800", "2900", "3000"],
    },
    Geared: {
      pit: ["1350", "1500", "1600", "2150", "2200", "2500"],
      overhead: ["17.5 FT"],
    },
    Gearless: {
      pit: ["300", "1350", "1500", "1600", "2150", "2200", "2500"],
      overhead: ["3000", "4800"],
    },
    Hydraulic: {
      pit: ["300"],
      overhead: ["3000"],
    },
  };
  //End Here Imran Khan 28/01/2026 Civil Requirements Options
  //Imran Khan 28/01/2026 cabin Config
  const cabinConfig = {
    wall: {
      MS: ["Epoxy RAL"],
      SS: ["Hairline", "Linen", "Honey Comb", "Moonrock Finish", "Mirror"],
    },
    ceiling: {
      MS: ["Epoxy RAL"],
      SS: ["Hairline", "Mirror Finish", "Designer"],
    },
    handrail: {
      MS: ["Painted", "Powder Coated"],
      SS: ["Hairline", "Mirror", "Golden"],
    },
    light: ["Square", "Round", "Tube Light", "Dotted"],
  };

  const showDoorConfig =
  offer?.all_doors_same === "DIFFERENT" &&
  offer?.total_stops &&
  offer?.number_of_openings &&
  Number(offer.total_stops) !== Number(offer.number_of_openings);
  //End Here cabin Config Imran Khan 28/01/2026

  //Imran Khan Added Make Modal Code Here 04-02-2026
  const [showMakeModal, setShowMakeModal] = useState(false);
  const [newMake, setNewMake] = useState({ name: "", type: "" });

  const handleChangeMake = (e) => {
    setNewMake({ ...newMake, [e.target.name]: e.target.value });
  };

  const handleMakeModelClose = () => {
    setNewMake({ name: "", type: "" });
    setShowMakeModal(false);
  };

  // Imran Khan handle submit make function to update the respective make options and offer state based on the type of make created 03/04/2026
  const handleSubmitMake = async () => {
    if (!newMake.name || !newMake.type) {
      return PubSub.publish("RECORD_ERROR_TOAST", {
        title: "Required",
        message: "Please fill all required fields",
      });
    }

    const result = await fuziElevatorsApi.createAccount(newMake);

    if (result?.success) {
      PubSub.publish("RECORD_SAVED_TOAST", {
        title: "Record created",
        message: "Make created successfully",
      });

      const created = {
        value: result.id,
        label: newMake.name,
        type: newMake.type,
      };

      if (newMake.type === "Motor Make") {
        setMotorMakeOption((prev) => [...prev, created]);
        setOffer((prev) => ({ ...prev, motor_make_id: result.id }));
      }
      if (newMake.type === "Door Make") {
        setDoorMakeOption((prev) => [...prev, created]);
        setOffer((prev) => ({ ...prev, door_make_id: result.id }));
      }
      if (newMake.type === "Control Panel Make") {
        setControlMakeOption((prev) => [...prev, created]);
        setOffer((prev) => ({ ...prev, control_panel_make_id: result.id }));
      }
      if (newMake.type === "Company Make") {
        setCompanyMakeOption((prev) => [...prev, created]);
        setOffer((prev) => ({
          ...prev,
          account_id: [...(prev.account_id || []), result.id],
          accounts: [...(prev.accounts || []), created],
        }));
      }

      handleMakeModelClose();
    }
  };
  //End Here Imran Khan Added Make Modal Code Here 04-02-2026

  //Imran khan Added Enquiry Lost Modal Code Here 07-01-2026
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setLostData({
      // is_lost_date: null,
      is_lost_remark: "",
      lost_by_reason: "",
    });
    setShow(false);
  };
  const handleShow = () => setShow(true);
  //End Here Imran khan Added Enquiry Lost Modal Code Here 07-01-2026
  //errors state
  const [errors, setErrors] = useState(!location.state ? initialErrors : {});
  useEffect(() => {
    console.log("errors", errors);
  }, [errors]);

  // validation state
  const [validated, setValidated] = useState(false);
  // Handle City & state values
  const [states, setStates] = useState([
    ...new Set(CityState.map((item) => item.state)),
  ]);
  // product state
  const [products, setProducts] = useState([]);
  // lead state
  const [leads, setLeads] = useState([]);
  // assign users state
  const [assignUsers, setAssignUsers] = useState([]);

  // assign users state
  const [showIsLostModal, setShowIsLostModal] = useState(false);
  //Imran Khan Added doorMakeOption, motorMakeOption, controlMakeOption on 06-02-2026
  const [doorMakeOption, setDoorMakeOption] = useState([]);
  const [motorMakeOption, setMotorMakeOption] = useState([]);
  const [controlMakeOption, setControlMakeOption] = useState([]);
  const [companyMakeOption, setCompanyMakeOption] = useState([]);
  const [accounts, setAccounts] = useState([]);
  // const stopRateMap = {
  //   2: 8550,
  //   3: 9800,
  //   4: 11050,
  //   5: 12300,
  //   6: 13550,
  //   7: 14800,
  //   8: 16050,
  //   9: 17300,
  //   10: 18550,
  // };
  const [segmentOptions, setSegmentOptions] = useState(constants?.SegmentOptions);//Added by shahir hussain for segment type field 02-02-2025

  // function getRateByStops(stops) {
  //   const baseStops = 2; const baseRate = 8550; const increment = 1250;
  //   if (stops < baseStops) return 0; return baseRate + (stops - baseStops) * increment;
  // }

  const handleCloseIsLostModal = () => {
    setShowIsLostModal(false);
  };
  async function init() {
    if (
      [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_PRODUCT].some((permission) => {
        return userInfo?.permissions?.map((p) => p.name).includes(permission);
      })
    ) {
      const fetchedProducts = await fuziElevatorsApi.fetchProducts();
      console.log("fetchedContacts", fetchedProducts);
      Array.isArray(fetchedProducts) &&
        setProducts(
          fetchedProducts?.map((fetchedProduct) => ({
            id: fetchedProduct?.id,
            name: `${fetchedProduct?.product_name || ""}`,
          })),
        );
    }

    if (
      [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_LEAD].some((permission) => {
        return userInfo?.permissions?.map((p) => p.name).includes(permission);
      })
    ) {
      const fetchedLeads = await fuziElevatorsApi.fetchLeadsForOffer();
      // console.log("fetchedLeads", fetchedLeads);
      Array.isArray(fetchedLeads) &&
        setLeads(
          fetchedLeads?.map((fetchedLead) => ({
            id: fetchedLead?.id,
            name: `${fetchedLead?.lead_name || ""} - ${fetchedLead?.enquiry_no || ""}`,
            leadData: fetchedLead,
          })),
        );
    }

    if (
      [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_USER].some((permission) => {
        return userInfo?.permissions?.map((p) => p.name).includes(permission);
      })
    ) {
      const resultedUsers = await fuziElevatorsApi.fetchUsers();
      resultedUsers &&
        Array.isArray(resultedUsers) &&
        setAssignUsers(resultedUsers);
    }

    if (
      [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_MAKE].some((permission) => {
        return userInfo?.permissions?.map((p) => p.name).includes(permission);
      })
    ) {
      const resultedAccounts = await fuziElevatorsApi.fetchAccounts();
      resultedAccounts &&
        Array.isArray(resultedAccounts) &&
        setAccounts(resultedAccounts);
    }
    //Imran Khan Added on 06-02-2026
    if (
      [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_MAKE].some((permission) => {
        return userInfo?.permissions?.map((p) => p.name).includes(permission);
      })
    ) {
      const resultedMakes = await fuziElevatorsApi.fetchAccountsByType();
      console.log("resultedMakes == ", resultedMakes);
      console.log("resultedMakes?.door_make == ", resultedMakes?.door_make);

      if (resultedMakes) {
        setDoorMakeOption(resultedMakes?.door_make);
        setMotorMakeOption(resultedMakes?.motor_make);
        setControlMakeOption(resultedMakes?.control_panel_make);
        setCompanyMakeOption(resultedMakes?.company_make);
      }
      // resultedMakes && Array.isArray(resultedMakes?.door_make) &&
      //   setDoorMakeOption(resultedMakes?.door_make)
    }
  }
  useEffect(() => {
    init();
  }, []);

  //Imran Khan 28/01/2026 Set Elevator Modal Data When Edit Offer
  // useEffect(() => {
  //   if (
  //     offer?.elevator_type &&
  //     offer?.elevator_capacity &&
  //     offer?.elevator_unit
  //   ) {
  //     setElevatorDraft({
  //       type: offer.elevator_type,
  //       capacity: offer.elevator_capacity,
  //       unit: offer.elevator_unit
  //     });
  //   }
  // }, [offer?.elevator_type]);
  //End Here Imran Khan 28/01/2026 Set Elevator Modal Data When Edit Offer

  //Imran 20/01/2026
  const handleLostChange = (e) => {
    const { name, value } = e?.target;

    setLostData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log("Target", e.target);
    if (name == "lead_id") {
      if (value == "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.leadName.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name == "offer_name") {
      if (value == "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.offerName.required },
        }));
      } else if (e?.target?.pattern && !RegExp(e.target.pattern).test(value)) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.offerName.invalid },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    if (name == "offer_status") {
      if (value == "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.status.required },
        }));
      } else if (e?.target?.pattern && !RegExp(e.target.pattern).test(value)) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.status.invalid },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name == "email") {
      if (
        value != "" &&
        e?.target?.pattern &&
        !RegExp(e.target.pattern).test(value)
      ) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.email.invalid },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name === "phone") {
      if (value === "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.phone.required },
        }));
      } else if (e?.target?.pattern && !RegExp(e.target.pattern).test(value)) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.phone.invalid },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name == "whatsapp_no") {
      if (
        value != "" &&
        e?.target?.pattern &&
        !RegExp(e.target.pattern).test(value)
      ) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.whatsappNumber.invalid },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    // else if (name == "tel_no") {
    //     if (value != "" && e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
    //         setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.tel.invalid } }));
    //     } else {
    //         setErrors((prev) => {
    //             delete prev[name];
    //             return { ...prev };
    //         });
    //     }
    // }
    else if (name == "owner_ids") {
      if (!value?.length) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.ownerIds.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name == "pincode") {
      if (
        value != "" &&
        e?.target?.pattern &&
        !RegExp(e.target.pattern).test(value)
      ) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.pinCode.invalid },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name == "country") {
      if (
        value != "" &&
        e?.target?.pattern &&
        !RegExp(e.target.pattern).test(value)
      ) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.country.invalid },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name == "highest_model_rate") {
      if (value == "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.highestModelRate.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name == "number_of_units") {
      if (value == "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.numberOfUnits.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    else if (name === "segment") {//Added by shahir hussain for segment type field 02-02-2025
      const values = Array.isArray(value)
        ? value?.map((item) => item?.value)
        : [];

      const segmentString = values.join(",");

      setOffer((prev) => ({
        ...prev,
        segment: segmentString,
      }));

      // validation
      // if (values?.length === 0) {
      //   setErrors((prev) => ({
      //     ...prev,
      //     segment: { message: validationMessages.segment.required },
      //   }));
      // } else {
      //   setErrors((prev) => {
      //     delete prev.segment;
      //     return { ...prev };
      //   });
      // }

      setValidated(true);
      return;
    }
    //
    //   if (name == 'offer_status' && value == 'Enquiry Lost') {
    //     offer.is_lost_date = formatDate(new Date());
    //     setShowIsLostModal(true);
    //   }

    //   setValidated(true);
    //   setOffer((prev) => ({ ...prev, [name]: value }));
    // };

    //Imran khan Update Enquiry Lost Modal Code Here 07-01-2026
    if (name === "offer_status" && value === "Offer Lost") {
      setLostData((prev) => ({
        ...prev,
        is_lost_date: new Date(),
      }));
      handleShow();
    }
    // if(name === "total_stops"){
    //     setOffer(prev => ({
    //     ...prev,
    //     [name]: value,
    //     base_rate:
    //       name === "total_stops"
    //         ? stopRateMap[value] || ""
    //         : prev.base_rate
    //   }));
    // }
    setValidated(true);
    console.log("TargetName", name);
    console.log("TargetValue", value);
    setOffer((prev) => ({ ...prev, [name]: value }));
  };
  //End Here Imran khan Update Enquiry Lost Modal Code Here 07-01-2026
  const handleLostSave = () => {
    setOffer((prev) => ({
      ...prev,
      is_lost_date: lostData.is_lost_date,
      is_lost_remark: lostData.is_lost_remark,
      lost_by_reason: lostData.lost_by_reason,
    }));
    handleClose();
  };

  // field validators
  const checkRequiredFields = () => {
    let isError = false;

    if (offer?.lead_id) {
      if (offer?.lead_id == "") {
        setErrors((prev) => ({
          ...prev,
          lead_id: { message: validationMessages.leadName.required },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["lead_id"];
          return { ...prev };
        });
      }
    }

    if (offer?.offer_name) {
      if (offer?.offer_name == "") {
        setErrors((prev) => ({
          ...prev,
          offer_name: { message: validationMessages.offerName.required },
        }));
        isError = true;
      } else if (
        regExPattern?.name &&
        !RegExp(regExPattern.name).test(offer.offer_name)
      ) {
        setErrors((prev) => ({
          ...prev,
          offer_name: { message: validationMessages.offerName.invalid },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["offer_name"];
          return { ...prev };
        });
      }
    }

    if (offer?.offer_status) {
      if (offer?.offer_status == "") {
        setErrors((prev) => ({
          ...prev,
          offer_status: { message: validationMessages.status.required },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["offer_status"];
          return { ...prev };
        });
      }
    }

    if (offer?.email) {
      if (
        offer?.email != "" &&
        regExPattern?.email &&
        !RegExp(regExPattern.email).test(offer.email)
      ) {
        setErrors((prev) => ({
          ...prev,
          email: { message: "Please provide Valid Email." },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["email"];
          return { ...prev };
        });
      }
    }

    if (offer?.phone) {
      if (offer?.phone == "") {
        setErrors((prev) => ({
          ...prev,
          phone: { message: "Please provide phone." },
        }));
        isError = true;
      } else if (
        regExPattern?.phone &&
        !RegExp(regExPattern.phone).test(offer.phone)
      ) {
        setErrors((prev) => ({
          ...prev,
          phone: { message: "Please provide Valid phone." },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["phone"];
          return { ...prev };
        });
      }
    }

    if (offer?.whatsapp_no) {
      if (
        offer?.whatsapp_no != "" &&
        regExPattern?.phone &&
        !RegExp(regExPattern.phone).test(offer.whatsapp_no)
      ) {
        setErrors((prev) => ({
          ...prev,
          whatsapp_no: { message: "Please provide Valid whatsapp number." },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["whatsapp_no"];
          return { ...prev };
        });
      }
    }

    // if (offer?.tel_no) {
    //     if (offer?.tel_no != "" && regExPattern?.tel && (!RegExp(regExPattern.tel).test(offer.tel_no))) {
    //         setErrors((prev) => ({ ...prev, 'tel_no': { message: validationMessages.tel.invalid } }));
    //         isError = true;

    //     } else {
    //         setErrors((prev) => {
    //             delete prev['tel_no'];
    //             return { ...prev };
    //         });
    //     }
    // }

    if (offer?.owner_ids) {
      if (!offer?.owner_ids?.length) {
        setErrors((prev) => ({
          ...prev,
          owner_ids: { message: validationMessages.ownerIds.required },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["owner_ids"];
          return { ...prev };
        });
      }
    }

    if (offer?.pincode) {
      if (
        offer?.pincode != "" &&
        regExPattern?.pinCode &&
        !RegExp(regExPattern.pinCode).test(offer.pincode)
      ) {
        setErrors((prev) => ({
          ...prev,
          pincode: { message: "Please provide valid pincode." },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["pincode"];
          return { ...prev };
        });
      }
    }

    if (offer?.country) {
      if (
        offer?.country != "" &&
        regExPattern?.name &&
        !RegExp(regExPattern.name).test(offer.country)
      ) {
        setErrors((prev) => ({
          ...prev,
          reference: { message: "Please provide valid country name." },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["country"];
          return { ...prev };
        });
      }
    }

    if (offer?.highest_model_rate) {
      if (offer?.highest_model_rate == "") {
        setErrors((prev) => ({
          ...prev,
          highest_model_rate: {
            message: validationMessages.highestModelRate.required,
          },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["highest_model_rate"];
          return { ...prev };
        });
      }
    }

    if (offer?.number_of_units) {
      if (offer?.number_of_units == "") {
        setErrors((prev) => ({
          ...prev,
          number_of_units: {
            message: validationMessages.numberOfUnits.required,
          },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["number_of_units"];
          return { ...prev };
        });
      }
    }

    // handle errors for required fields
    if (!offer?.lead_id) {
      setErrors((prev) => ({
        ...prev,
        lead_id: { message: validationMessages.leadName.required },
      }));
      isError = true;
    }

    if (!offer?.offer_name) {
      setErrors((prev) => ({
        ...prev,
        offer_name: { message: validationMessages.offerName.required },
      }));
      isError = true;
    }

    if (!offer?.offer_status) {
      setErrors((prev) => ({
        ...prev,
        offer_status: { message: validationMessages.status.required },
      }));
      isError = true;
    }

    if (!offer?.phone) {
      setErrors((prev) => ({
        ...prev,
        phone: { message: validationMessages.phone.required },
      }));
      isError = true;
    }

    if (!offer?.owner_ids?.length) {
      setErrors((prev) => ({
        ...prev,
        owner_ids: { message: validationMessages.ownerIds.required },
      }));
      isError = true;
    }

    if (!offer?.highest_model_rate) {
      setErrors((prev) => ({
        ...prev,
        highest_model_rate: {
          message: validationMessages.highestModelRate.required,
        },
      }));
      isError = true;
    }

    if (!offer?.number_of_units) {
      setErrors((prev) => ({
        ...prev,
        number_of_units: { message: validationMessages.numberOfUnits.required },
      }));
      isError = true;
    }
    return isError;
  };

  // onSubmit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("offer", offer);
    console.log("errors", errors);
    if (checkRequiredFields()) {
      setValidated(true);
      return;
    }
    console.log("offer", offer);
    console.log("errors", errors);

    if (Object?.keys(errors)?.length != 0) {
      setValidated(true);
      return;
    }

    // copy the obj to send as payload
    const record = { ...offer };

    // handle date format
    if (record?.offer_date) {
      record.offer_date = formatDate(record?.offer_date);
    }
    if (record?.date_of_birth) {
      record.date_of_birth = formatDate(record?.date_of_birth);
    }
    if (record?.anniversary_date) {
      record.anniversary_date = formatDate(record?.anniversary_date);
    }

    // delete unnecessary fields
    delete record?.lead_name;
    delete record?.product_name;
    delete record?.offer_amount;
    delete record?.owner_name;

    // handle numeric fields
    record.qty = record?.qty == "" ? 0 : record?.qty;
    record.highest_model_rate =
      record?.highest_model_rate == "" ? 0 : record?.highest_model_rate;
    record.number_of_units =
      record?.number_of_units == "" ? 0 : record?.number_of_units;
    record.offer_ref_no = record?.offer_ref_no == "" ? 0 : record?.offer_ref_no;

    // handle date fields
    record.offer_date = record?.offer_date == "" ? null : record?.offer_date;
    record.date_of_birth =
      record?.date_of_birth == "" ? null : record?.date_of_birth;
    record.anniversary_date =
      record?.anniversary_date == "" ? null : record?.anniversary_date;
    record.is_lost_date =
      record?.is_lost_date == "" ? null : record?.is_lost_date;

    // handel account_id make
    record.account_id = record?.accounts
      ?.filter((item) => item?.value)
      ?.map((item) => item?.value);
    delete record.accounts;
    // handel owner_ids
    record.owner_ids = record?.owner_ids
      ?.filter((item) => item?.value)
      ?.map((item) => item?.value);
    console.log("offer ==>", record);
    // //========= Logic to perform Create or Edit ======
    if (record.id) {
      // console.log('Updated');
      const result = await fuziElevatorsApi.saveOffer(record);
      if (result?.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Update",
          message: "Record updated successfully",
        });
        navigate(`/contacts/${record?.id}`, { state: record });
        navigate(`${ROUTES.OFFER.LIST}/${record?.id}`, { state: record });
      } else {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Record Update Error",
          message: result?.errors,
        });
      }
    } else {
      // console.log('Created');
      const result = await fuziElevatorsApi.createOffer(record);
      if (result?.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record created",
          message: "Record created successfully",
        });
        navigate(`${ROUTES.OFFER.LIST}/${result.id}`, { state: result?.data });
      } else {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Record Save Error",
          message: result?.errors,
        });
      }
    }
  };

  const handleCancel = () => {
    if (offer.id) {
      navigate(`${ROUTES.OFFER.LIST}/${offer.id}`, { state: offer });
    } else {
      navigate(ROUTES.OFFER.LIST);
    }
  };

  const onLeadSelect = async (id) => {
    const leadData = await fuziElevatorsApi.fetchLeadById(id);
    if (leadData) {
      const offerRecord = {};
      offerRecord.offer_name = leadData.lead_name || "";
      offerRecord.email = leadData.email || "";
      offerRecord.phone = leadData.phone || "";
      offerRecord.whatsapp_no = leadData.whatsapp_no || "";
      offerRecord.tel_no = leadData?.teliphone || "";
      offerRecord.date_of_birth = leadData?.date_of_birth || "";
      offerRecord.anniversary_date = leadData?.anniversary_date || "";
      offerRecord.owner_ids = leadData?.owner_ids || [];
      offerRecord.owner_name = leadData?.owner_name || "";

      // Service Info
      offerRecord.product_id = leadData.product_id || null;
      offerRecord.product_name = leadData.product_name || "";
      // offerRecord.accounts = leadData.accounts?.filter((item) => item.value);
      offerRecord.accounts = leadData.accounts?.filter((item) => item.value);
      offerRecord.account_id = leadData.accounts
        ?.filter((item) => item.value)
        ?.map((item) => item.value);
      offerRecord.offer_remark = leadData.remark || "";

      // Customer Info
      offerRecord.offer_type = leadData.customer_type || "";
      offerRecord.company_name = leadData.company_name || "";
      offerRecord.sector = leadData.sector || "";
      offerRecord.is_gst = leadData.is_gst || "";
      offerRecord.gst_no = leadData.gst_no || "";
      offerRecord.competitor_name = leadData.competitor_name || "";

      // Address Info
      // let filteredSiteVisits = siteVisits.filter((siteVisit) => siteVisit.visit_status == "Complete");
      offerRecord.site_address = leadData?.address || "";
      offerRecord.state = leadData.state || "";
      offerRecord.city = leadData.city || "";
      offerRecord.office_address = leadData.address || "";
      offerRecord.office_city = leadData.office_city || "";
      offerRecord.pincode = leadData.pincode || "";
      offerRecord.country = leadData.country || "";

      // offerRecord.offer_status = "Pending";
      // Other Info
      // offerRecord.number_of_units = leadData.qty || null;//Commented by shahir hussain 28-01-2025
      offerRecord.number_of_units = leadData.qty || 1;//Added by shahir hussain 28-01-2025

      offerRecord.area = leadData?.area || "";//Added by shahir hussain
      offerRecord.segment = leadData?.segment || "";//Added by shahir hussain for segment type field 02-02-2025

      if (offerRecord?.offer_name) {
        setErrors((prev) => {
          delete prev["offer_name"];
          return { ...prev };
        });
      }
      if (offerRecord?.phone) {
        setErrors((prev) => {
          delete prev["phone"];
          return { ...prev };
        });
      }
      if (offerRecord?.owner_ids) {
        setErrors((prev) => {
          delete prev["owner_ids"];
          return { ...prev };
        });
      }
      if (offerRecord?.number_of_units) {
        setErrors((prev) => {
          delete prev["number_of_units"];
          return { ...prev };
        });
      }

      setOffer((prev) => ({ ...prev, ...offerRecord }));
    }
  };

  // const handleSubmitQuery = async () =>{
  //   console.log("offer enquiry == ", offer);
  // }

  return (
    <Container className="pb-5">
      {/* Imran khan Update Enquiry Lost Modal Code Here 07-01-2026 */}
      <>
        <Modal
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>REASON OF OFFER LOST</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Col lg={12}>
              <Form.Group>
                <Form.Label>Lost Date</Form.Label>
                <Form.Control
                  disabled
                  value={formatDateForCreatedDate(offer?.is_lost_date)}
                />
              </Form.Group>
            </Col>
            <Col lg={12} className="mt-2">
              <Form.Group>
                <Form.Label>Offer Lost Reason</Form.Label>
                <Form.Control
                  type="text"
                  name="is_lost_remark"
                  placeholder="Offer Lost Remark"
                  value={lostData.is_lost_remark}
                  onChange={handleLostChange}
                />
              </Form.Group>
            </Col>
            <Col lg={12} className="mt-2">
              <Form.Group>
                <Form.Label>Lost By (Company)</Form.Label>
                <Form.Control
                  type="text"
                  name="lost_by_reason"
                  placeholder="Offer by Reason"
                  value={lostData.lost_by_reason}
                  onChange={handleLostChange}
                />
              </Form.Group>
            </Col>

            {/* I will not close if you click outside me. Do not even try to press
                escape key. */}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleLostSave}>
              Save
            </Button>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            {/* <Button variant="primary">Understood</Button> */}
          </Modal.Footer>
        </Modal>
      </>
      {/* End Here Imran khan Update Enquiry Lost Modal Code Here 07-01-2026 */}
      <Row>
        <Col md={12} className="sticky-breadcrumb">
          <Breadcrumb>
            <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item onClick={() => navigate(ROUTES.OFFER.LIST)}>
              Offers
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col md={12}>
          <Form
            className=""
            onSubmit={() => handleSubmit}
            noValidate
            validated={validated}
          >
            <Card className="shadow">
              <CardHeader className="bg-custom text-white sticky-card-header">
                <Row className="w-100">
                  <Col lg={6} className="">
                    <div className="d-flex align-items-center h-100 gap-3">
                      {offer?.id ? (
                        <h5 className="m-0">
                          Edit Offer {offer?.offer_name || ""}
                        </h5>
                      ) : (
                        <h5 className="m-0">Create Offer</h5>
                      )}
                    </div>
                  </Col>
                  <Col lg={6} className="p-0">
                    <Stack direction="horizontal" className="float-end" gap={2}>
                      <Button
                        size="sm"
                        className="btn-save"
                        onClick={handleSubmit}
                      >
                        Save
                      </Button>
                      <Button
                        size="sm"
                        className="btn-delete"
                        onClick={handleCancel}
                      >
                        Cancel
                      </Button>
                    </Stack>
                  </Col>
                </Row>
              </CardHeader>

              <CardBody className="">
                <Row lg={12} className="view-form ">
                  <>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicStateLead"
                        >
                          Lead
                        </Form.Label>

                        <div className="d-flex align-items-center gap-2">
                          <div className="flex-grow-1">
                            <Select
                              required
                              classNamePrefix="react-select"
                              className={`${offer?.lead_id ? "custom-select-valid" : "custom-select-invalid"}`}
                              placeholder="Select your lead"
                              options={leads?.map((lead) => ({
                                value: lead?.id,
                                label: lead?.name,
                              }))}
                              onChange={(e) => {
                                handleChange({
                                  target: { name: "lead_id", value: e.value },
                                });
                                handleChange({
                                  target: { name: "lead_name", value: e.label },
                                });
                                onLeadSelect(e.value);
                              }}
                              value={
                                offer?.lead_id
                                  ? {
                                    value: offer?.lead_id,
                                    label: offer?.lead_name,
                                  }
                                  : ""
                              }
                              isDisabled={
                                offer?.id &&
                                !helper.checkPermission(Constant.SUPER_ADMIN)
                              }
                            />
                          </div>
                          <Button
                            size="sm"
                            variant="success"
                            disabled={!offer?.lead_id}
                            onClick={() =>
                              offer?.lead_id && onLeadSelect(offer?.lead_id)
                            }
                            className="refresh-btn"
                          >
                            <i className="fa fa-refresh"></i>
                          </Button>
                        </div>

                        {errors?.lead_id?.message && !offer.lead_id && (
                          <div className="feedback-invalid">
                            {errors?.lead_id?.message}
                          </div>
                        )}
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicOfferName"
                        >
                          Offer Name
                        </Form.Label>
                        <Form.Control
                          required
                          pattern={regExPattern.name}
                          type="text"
                          name="offer_name"
                          placeholder="Enter offer name"
                          value={offer?.offer_name || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.offer_name?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicOfferDate"
                        >
                          Offer Date
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="offer_date"
                          value={formatDate(offer?.offer_date)}
                          onChange={handleChange}
                          max={formatDate(new Date())}
                          onKeyDown={(e) => e.preventDefault()}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.offer_date?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicOfferStatus"
                        >
                          Offer Status
                        </Form.Label>
                        <FormSelect
                          required
                          name="offer_status"
                          value={offer?.offer_status || ""}
                          onChange={handleChange}
                        >
                          <option value={""}>--select status--</option>
                          {Constant.OFFER_STATUS_VALUES?.map(
                            (status, index) => (
                              <option value={status.label || ""} key={index}>
                                {status.label || ""}
                              </option>
                            ),
                          )}
                        </FormSelect>
                        <Form.Control.Feedback type="invalid">
                          {errors?.offer_status?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicEmail"
                        >
                          Email
                        </Form.Label>
                        <Form.Control
                          pattern={regExPattern.email}
                          type="email"
                          name="email"
                          placeholder="Enter email"
                          value={offer?.email || ""}
                          onChange={handleChange}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.email?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicPhone"
                        >
                          Phone
                        </Form.Label>
                        <Form.Control
                          required
                          type="text"
                          name="phone"
                          placeholder="Enter phone"
                          value={offer?.phone || ""}
                          onChange={handleChange}
                          maxLength={10}
                          pattern={regExPattern.phone}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.phone?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicPhone"
                        >
                          WhatsApp Number.
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="whatsapp_no"
                          placeholder="Enter whatsApp number"
                          value={offer?.whatsapp_no || ""}
                          onChange={handleChange}
                          maxLength={10}
                          pattern={regExPattern.phone}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.whatsapp_no?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicTelephoneNumber"
                        >
                          Telephone Number
                        </Form.Label>
                        <Form.Control
                          // type="tel"
                          name="tel_no"
                          placeholder="Enter telephone number"
                          value={offer?.tel_no || ""}
                          // pattern={regExPattern.tel}
                          onChange={handleChange}
                          title="provide valid"
                        />

                        {errors?.tel_no?.message && (
                          <div className="feedback-invalid">
                            {errors?.tel_no?.message}
                          </div>
                        )}
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formDateOfBirth"
                        >
                          Date of Birth
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="date_of_birth"
                          placeholder="Select date of birth"
                          value={
                            offer?.date_of_birth
                              ? formatDate(offer.date_of_birth)
                              : ""
                          }
                          onChange={handleChange}
                          max={formatDate(new Date())}
                          onKeyDown={(e) => e.preventDefault()}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.date_of_birth?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formAnniversaryDate"
                        >
                          Anniversary Date
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="anniversary_date"
                          placeholder="Select anniversary date"
                          value={
                            offer?.anniversary_date
                              ? formatDate(offer.anniversary_date)
                              : ""
                          }
                          onChange={handleChange}
                          max={formatDate(new Date())}
                          onKeyDown={(e) => e.preventDefault()}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.anniversary_date?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    {/* <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicOwner"
                        >
                          Assign Staff
                        </Form.Label>
                        <Select
                          required
                          name="owner_ids"
                          className={`${offer?.owner_ids ? 'custom-select-valid' : 'custom-select-invalid'}`}
                          onChange={(e) => {
                            handleChange({ target: { name: "owner_ids", value: e.value } });
                            handleChange({ target: { name: "owner_name", value: e.label } });
                          }}
                          options={assignUsers?.map((item) => ({ value: item.id, label: item.username }))}
                          value={offer?.owner_ids ? { value: offer?.owner_ids || "", label: offer?.owner_name || "" } : ""}
                        />
                        {(errors?.owner_ids?.message && (!offer.owner_ids)) && <div className="feedback-invalid">
                          {errors?.owner_ids?.message}
                        </div>}
                      </Form.Group>
                    </Col> */}

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicLeadDelegatedUsers"
                        >
                          Assign Users
                        </Form.Label>
                        <Select
                          isMulti
                          classNamePrefix="react-select"
                          className={`${Array.isArray(offer?.owner_ids) && offer?.owner_ids?.length > 0 ? "custom-select-valid" : "custom-select-invalid"}`}
                          placeholder="Select your Assign Staff"
                          options={assignUsers?.map((item) => ({
                            value: item.id,
                            label: item.username,
                          }))}
                          value={offer?.owner_ids?.filter((item) => item.value)}
                          onChange={(e) => {
                            handleChange({
                              target: { name: "owner_ids", value: e },
                            });
                          }}
                        />
                        {errors?.owner_ids?.message && validated && (
                          <div className="feedback-invalid">
                            {errors?.owner_ids?.message}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </>

                  <>
                    <Col lg={12} className="section-header">
                      SERVICE INFORMATION
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicStateProduct"
                        >
                          Product
                        </Form.Label>

                        <Select
                          placeholder="Select your product"
                          classNamePrefix="react-select"
                          options={products?.map((product) => ({
                            value: product?.id,
                            label: product?.name,
                          }))}
                          onChange={(e) => {
                            handleChange({
                              target: { name: "product_id", value: e.value },
                            });
                            handleChange({
                              target: { name: "product_name", value: e.label },
                            });
                          }}
                          value={
                            offer?.product_id
                              ? {
                                value: offer?.product_id,
                                label: offer?.product_name,
                              }
                              : ""
                          }
                        ></Select>
                        <Form.Control.Feedback type="invalid">
                          {errors?.product_id?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    {/* <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicState"
                        >
                          Make
                        </Form.Label>

                        <Select
                          isMulti
                          placeholder="Select your makes"
                          classNamePrefix="react-select"
                          options={accounts?.map((account) => ({
                            value: account?.id,
                            label: account?.name,
                          }))}
                          onChange={(e) => {
                            handleChange({
                              target: { name: "accounts", value: e },
                            });

                            handleChange({
                              target: {
                                name: "account_id",
                                value: e.map((x) => x.value),
                              },
                            });
                          }}
                          value={accounts
                            ?.filter((acc) =>
                              offer?.account_id?.includes(acc.id),
                            )
                            ?.map((acc) => ({
                              value: acc.id,
                              label: acc.name,
                            }))}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.account_id?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col> */}
                    {/*Imran Khan update Make field show only Company Type data on 06-02-2026 */}
                    {/* <Col lg={6}>
                      <Form.Group>
                        <Form.Label className="form-view-label">
                          Make
                        </Form.Label>

                        <Select
                          isMulti
                          placeholder="Select your makes"
                          options={companyMakeOption}
                          value={
                            companyMakeOption?.filter((opt) =>
                              offer?.account_id?.includes(opt.value),
                            ) || []
                          }
                          onChange={(e) => {
                            handleChange({
                              target: { name: "accounts", value: e },
                            });

                            handleChange({
                              target: {
                                name: "account_id",
                                value: e?.map((x) => x.value) || [],
                              },
                            });
                          }}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.account_id?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col> */}
                    {/*Added + Imran Khan 09-02-2026  */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label className="form-view-label">
                          Make
                        </Form.Label>

                        <InputGroup>
                          <Select
                            className="w-75"
                            isMulti
                            placeholder="Select your makes"
                            options={companyMakeOption}
                            value={
                              companyMakeOption?.filter((opt) =>
                                offer?.account_id?.includes(opt.value),
                              ) || []
                            }
                            onChange={(e) => {
                              handleChange({
                                target: { name: "accounts", value: e },
                              });

                              handleChange({
                                target: {
                                  name: "account_id",
                                  value: e?.map((x) => x.value) || [],
                                },
                              });
                            }}
                          />

                          {/* ➕ Add New Make */}
                          <InputGroup.Text className="d-flex justify-content-center align-items-center w-25 p-0 bg-white">
                            <Button
                              variant="link"
                              className="p-0 border-0"
                              onClick={() => {
                                setNewMake({ name: "", type: "Company Make" });
                                setShowMakeModal(true);
                              }}
                            >
                              <i className="fa fa-plus fa-xl text-success" />
                            </Button>
                          </InputGroup.Text>
                        </InputGroup>

                        <Form.Control.Feedback type="invalid">
                          {errors?.account_id?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    {/* <Col lg={6}>
                      <Form.Group>
                        <Form.Label>Make</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter make name"
                          name="make"
                          value={offer?.make || ""}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col> */}

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicOfferRemark"
                        >
                          Offer Remark
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="offer_remark"
                          placeholder="Enter offer remark"
                          value={offer?.offer_remark || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.offer_remark?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </>

                  <>
                    <Col md={12} className="section-header">
                      CUSTOMER Information
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicOfferType"
                        >
                          Customer Type
                        </Form.Label>
                        <FormSelect
                          name="offer_type"
                          value={offer?.offer_type || ""}
                          onChange={handleChange}
                        >
                          <option value={""}>--select type--</option>
                          <option value={"Individual"}>Individual</option>
                          <option value={"Corporate"}>Corporate</option>
                        </FormSelect>
                        <Form.Control.Feedback type="invalid">
                          {errors?.offer_type?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {offer?.offer_type == "Corporate" && (
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label>Company Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter company name"
                            name="company_name"
                            value={offer?.company_name || ""}
                            onChange={handleChange}
                          />
                        </Form.Group>
                      </Col>
                    )}

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicSector "
                        >
                          Sector
                        </Form.Label>
                        <Form.Select
                          name="sector"
                          value={offer?.sector || ""}
                          onChange={handleChange}
                        >
                          <option value="">---select sector---</option>
                          {[
                            "Government site",
                            "Customer is private",
                            "Government Customer direct with us",
                          ].map((item, index) => (
                            <option value={item} key={index}>
                              {item}
                            </option>
                          ))}
                        </Form.Select>

                        <Form.Control.Feedback type="invalid">
                          {errors?.sector?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicIsGst"
                        >
                          Is GST Applicable
                        </Form.Label>
                        <FormSelect
                          name="is_gst"
                          value={offer?.is_gst || ""}
                          onChange={handleChange}
                        >
                          <option value={""}>--select--</option>
                          <option value={"Yes"}>Yes</option>
                          <option value={"No"}>No</option>
                        </FormSelect>
                        <Form.Control.Feedback type="invalid">
                          {errors?.is_gst?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    {offer?.is_gst === "Yes" && (
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label>GST No</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter gst number"
                            name="gst_no"
                            value={offer?.gst_no?.toUpperCase() || ""}
                            // onChange={handleChange}
                            onChange={(e) => {
                              const value = e.target.value;
                              setOffer((prev) => ({
                                ...prev,
                                gst_no: value.replace(/\s+/g, "").toUpperCase(),
                              }));
                            }}
                          />
                        </Form.Group>
                        <Form.Control.Feedback type="invalid">
                          {errors?.gst_no?.message}
                        </Form.Control.Feedback>
                      </Col>
                    )}

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCompetitorName "
                        >
                          Competitor Name
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="competitor_name"
                          placeholder="Enter competitor name"
                          value={offer?.competitor_name || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                          pattern={regExPattern.name}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.competitor_name?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {/* Added by shahir hussain for segment type field 02-02-2025 */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label className="form-view-label">
                          Segment Type
                        </Form.Label>

                        <Select
                          isMulti
                          placeholder="Select Segment Type"
                          classNamePrefix="react-select"
                          options={segmentOptions}
                          value={
                            typeof offer?.segment === "string" && offer?.segment
                              ? segmentOptions?.filter((opt) =>
                                  offer?.segment
                                    ?.split(",")
                                    .includes(opt?.value),
                                )
                              : []
                          }
                          onChange={(selectedOptions) => {
                            handleChange({
                              target: {
                                name: "segment",
                                value: selectedOptions,
                              },
                            });
                          }}
                        // className={
                        //   offer?.segment && offer?.segment?.length > 0
                        //     ? "custom-select-valid"
                        //     : "custom-select-invalid"
                        // }
                        />

                        {errors?.segment?.message && validated && (
                          <div className="feedback-invalid">
                            {errors?.segment?.message}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </>

                  <>
                    <Col md={12} className="section-header">
                      Offer Information
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicHighestModelRate"
                        >
                          Offer Rate
                        </Form.Label>
                        <Form.Control
                          required
                          type="number"
                          name="highest_model_rate"
                          placeholder="Enter offer rate"
                          onKeyDownCapture={(e) =>
                            ["e", "E", "+", "-"].includes(e.key) &&
                            e.preventDefault()
                          }
                          value={offer?.highest_model_rate || ""}
                          onChange={handleChange}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.highest_model_rate?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicOFFERAMOUNT"}
                        >
                          OFFER AMOUNT
                        </Form.Label>
                        <Form.Control
                          disabled
                          placeholder="Enter offer amount"
                          value={
                            (offer?.highest_model_rate != null &&
                              offer?.highest_model_rate != undefined &&
                              offer?.number_of_units != null &&
                              offer?.number_of_units != undefined &&
                              offer?.highest_model_rate *
                                offer?.number_of_units) ||
                            0
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.number_of_units?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicNumberOfUnits"}
                        >
                          Number Of Units
                        </Form.Label>
                        <Form.Control
                          required
                          type="number"
                          name="number_of_units"
                          placeholder="Enter number of units"
                          onKeyDownCapture={(e) =>
                            ["e", "E", "+", "-"].includes(e.key) &&
                            e.preventDefault()
                          }
                          // value={offer?.number_of_units || ""}
                          value={offer?.number_of_units}
                          pattern={regExPattern.quantity}
                          onChange={handleChange}
                          disabled
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.number_of_units?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicPassengerCapacity"}
                        >
                          Passenger Capacity
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="passenger_capacity"
                          placeholder="Enter passenger capacity"
                          value={offer?.passenger_capacity || ""}
                          onChange={handleChange}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.passenger_capacity?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {/* Imran Khan Added Elevator Type on 28/01/2026 */}
                    {/* <Col lg={6}>
                      <Form.Group>
                        <Form.Label className="form-view-label">
                          Elevator Type
                        </Form.Label>
                        <FormSelect
                          value={elevatorDraft.type}
                          onChange={(e) => {
                            const selected = e.target.value;

                            setElevatorDraft({
                              type: selected,
                              capacity: null,
                              unit: ""
                            });

                            setShowElevatorModal(true);
                          }}
                        >
                          <option value="">--select elevator type--</option>
                          <option value="Passenger">Passenger</option>
                          <option value="Hospital">Hospital</option>
                          <option value="Goods">Goods</option>
                          <option value="Dumbwaiter">Dumbwaiter</option>
                        </FormSelect>

                      </Form.Group>
                    </Col>
                    <Modal show={showElevatorModal} onHide={() => setShowElevatorModal(false)}>
                      <Modal.Header closeButton>
                        <Modal.Title>
                          Configure {elevatorDraft.type} Elevator
                        </Modal.Title>
                      </Modal.Header>

                      <Modal.Body>
                        {(() => {
                          const config = getCapacityOptions(elevatorDraft.type);

                          return (
                            <>
                              <FormSelect
                                value={elevatorDraft.capacity ?? ""}
                                onChange={(e) => {
                                  const cap = Number(e.target.value);
                                  setElevatorDraft((prev) => ({
                                    ...prev,
                                    capacity: cap,
                                    unit: config.unitMap
                                      ? config.unitMap[cap]
                                      : config.unit
                                  }));
                                }}
                              >
                                <option value="">--select capacity--</option>
                                {config.list.map((c) => (
                                  <option key={c} value={c}>{c}</option>
                                ))}
                              </FormSelect>

                              <Form.Control
                                className="mt-2"
                                value={elevatorDraft.unit}
                                readOnly
                              />
                            </>
                          );
                        })()}
                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          onClick={() => {
                            setElevatorDraft({ type: "", capacity: null, unit: "" });
                            setShowElevatorModal(false);
                          }}
                        >
                          Cancel
                        </Button>

                        <Button
                          disabled={!elevatorDraft.capacity}
                          onClick={() => {
                            setOffer((prev) => ({
                              ...prev,
                              elevator_type: elevatorDraft.type,
                              elevator_capacity: elevatorDraft.capacity,
                              elevator_unit: elevatorDraft.unit
                            }));

                            setElevatorDraft({ type: "", capacity: null, unit: "" });
                            setShowElevatorModal(false);
                          }}
                        >
                          Save
                        </Button>
                      </Modal.Footer>
                    </Modal> */}
                    {/* Imran Khan Added Elevator Type on 02/02/2026 */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicElevatorType"}
                        >
                          Elevator Type
                        </Form.Label>

                        <Form.Control
                          as="select"
                          name="elevator_type"
                          value={offer?.elevator_type || ""}
                          onChange={(e) =>
                            handleChange(e, { elevator_capacity: "" })
                          }
                        >
                          <option value="">--select elevator type--</option>
                          <option value="Passenger">Passenger</option>
                          <option value="Hospital">Hospital</option>
                          <option value="Goods">Goods</option>
                          <option value="Dumbwaiter">Dumbwaiter</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    {offer?.elevator_type && (
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor={"formBasicElevatorCapacity"}
                          >
                            Elevator Capacity
                          </Form.Label>

                          <Form.Control
                            as="select"
                            name="elevator_capacity"
                            value={offer?.elevator_capacity || ""}
                            onChange={handleChange}
                          >
                            <option value="">--select capacity--</option>

                            {offer.elevator_type === "Passenger" &&
                              [4, 6, 8, 10, 13, 16, 20].map((c) => (
                                <option key={c} value={c}>
                                  {c} Passenger
                                </option>
                              ))}

                            {offer.elevator_type === "Hospital" && (
                              <>
                                <option value="15">
                                  15 Passenger cum Stretcher
                                </option>
                                <option value="20">20 Passenger cum Bed</option>
                                <option value="26">26 Passenger cum Bed</option>
                              </>
                            )}

                            {offer.elevator_type === "Goods" &&
                              [
                                500, 1000, 1500, 2000, 2500, 3000, 4000, 5000,
                              ].map((c) => (
                                <option key={c} value={c}>
                                  {c} Kg
                                </option>
                              ))}

                            {offer.elevator_type === "Dumbwaiter" &&
                              [100, 150, 200, 250, 500].map((c) => (
                                <option key={c} value={c}>
                                  {c} Kg
                                </option>
                              ))}
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    )}

                    {/* End here Imran Khan */}
                    {/* <Col lg={6}>
                    {/* <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicTotalNumberOfStop"}
                        >
                          Total Number Of Stop
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="total_stops"
                          placeholder="Enter total stops"
                          value={offer?.total_stops || ""}
                          onChange={handleChange}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.total_stops?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col> */}

                    {/* Imran Khan Added Total No of stop on 22/01/2026 */}
                   <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicTotalNumberOfStop"
                        >
                          Total Number Of Stop
                        </Form.Label>
                        <Form.Select
                          name="total_stops"
                          value={offer?.total_stops || ""}
                          onChange={handleChange}
                          isInvalid={!!errors?.total_stops}
                        >
                          <option value="">Select total stops</option>

                          {[...Array(19)].map((_, index) => {
                            const value = index + 2; // 2 to 20
                            return (
                              <option key={value} value={value}>
                                {value}
                              </option>
                            );
                          })}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors?.total_stops?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {/* <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicNumberOfOpening"}
                        >
                          Number Of Opening
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="number_of_openings"
                          placeholder="Enter number of openings"
                          value={offer?.number_of_openings || ""}
                          onChange={handleChange}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.number_of_openings?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col> */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label className="form-view-label">
                          Number Of Opening
                        </Form.Label>
                        <Form.Select
                          name="number_of_openings"
                          value={offer?.number_of_openings || ""}
                          onChange={handleChange}
                          isInvalid={!!errors?.number_of_openings}
                        >
                          <option value="">Select openings</option>
                          {[...Array(19)].map((_, index) => {
                            const value = index + 2; // 2–20
                            return (
                              <option key={value} value={value}>
                                {value}
                              </option>
                            );
                          })}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors?.number_of_openings?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    {/* Commented By Farhan Khan on 18-March-2026 Client Requested AMC Ticket No : 1046 <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicFloorName"}
                        >
                          Name Of Different Floor
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="floor_name"
                          placeholder="Enter floor name"
                          value={offer?.floor_name || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.floor_name?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col> */}

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicNameOfFloors"}
                        >
                          Floor Counts
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="floor_counts"
                          placeholder="Enter floor counts"
                          value={offer?.floor_counts || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.floor_counts?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {/* <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicMotor"}
                        >
                          Motor
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="motor"
                          placeholder="Enter motor"
                          value={offer?.motor || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.motor?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col> */}

                    {/* Imran Khan Added Motor Dropdown on 27/01/2026 */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label className="form-view-label">
                          Motor Type
                        </Form.Label>

                        <Form.Select
                          name="motor"
                          value={offer?.motor ?? ""}
                          onChange={(e) => handleChange(e)}
                        >
                          <option value="">Select Motor Type</option>
                          <option value="Geared">Geared</option>
                          <option value="Gearless">Gearless</option>
                          <option value="Vacuum">Vacuum</option>
                          <option value="Hydraulic">Hydraulic</option>
                        </Form.Select>

                        <Form.Control.Feedback type="invalid">
                          {errors?.motor?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {/* End here Imran Khan */}
                    {/* Imran Khan Added Lift Speed on 22/01/2026 */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicSpeed"
                        >
                          Lift Type
                        </Form.Label>

                        <Form.Select
                          name="lift_speed"
                          placeholder="Enter lift speed"
                          value={offer?.lift_speed || ""}
                          onChange={handleChange}
                          isInvalid={!!errors?.lift_speed}
                        >
                          <option value="">Select Lift Type</option>
                          <option value="Geared">Geared</option>
                          <option value="Gearless">Gearless</option>
                          <option value="Vacuum">Vacuum</option>
                          <option value="Hydraulic">Hydraulic</option>
                        </Form.Select>

                        <Form.Control.Feedback type="invalid">
                          {errors?.lift_speed?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {/*Imran Khan Added Motor Make with Add New Functionality on 04/02/2026*/}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label className="form-view-label">
                          Motor Make
                        </Form.Label>

                        <InputGroup>
                          <Select
                            className="w-75"
                            placeholder="Select Motor Make"
                            // options={accounts
                            //   ?.filter(acc => acc.type === "Motor Make")
                            //   ?.map(acc => ({
                            //     value: acc.id,
                            //     label: acc.name
                            //   }))}
                            options={motorMakeOption}
                            value={
                              offer?.motor_make_id
                                ? {
                                    value: offer.motor_make_id,
                                    label: motorMakeOption?.find(
                                      (a) => a.value === offer.motor_make_id,
                                    )?.label,
                                  }
                                : null
                            }
                            onChange={(e) =>
                              handleChange({
                                target: {
                                  name: "motor_make_id",
                                  value: e?.value || "",
                                },
                              })
                            }
                          />

                          <InputGroup.Text className="d-flex justify-content-center align-items-center w-25 p-0 bg-white">
                            <Button
                              variant="link"
                              className="p-0 border-0"
                              onClick={() => {
                                setNewMake({ name: "", type: "Motor Make" });
                                setShowMakeModal(true);
                              }}
                            >
                              <i className="fa fa-plus fa-xl text-success" />
                            </Button>
                          </InputGroup.Text>
                        </InputGroup>
                      </Form.Group>
                    </Col>

                    {/* End here Imran Khan */}
                    {/* Imran Khan Added Motor Model No on 27/01/2026 */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label className="form-view-label">
                          Motor Model No.
                        </Form.Label>

                        <Form.Control
                          type="number"
                          name="motor_model_no"
                          placeholder="Enter model no."
                          value={offer?.motor_model_no || ""}
                          onChange={handleChange}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.motor_model_no?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label className="form-view-label">
                          Motor KW
                        </Form.Label>
                        <Form.Control
                          type="number"
                          name="motor_kw"
                          placeholder="Enter motor kw"
                          value={offer?.motor_kw || ""}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.motor_kw?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label className="form-view-label">
                          Motor Amp
                        </Form.Label>
                        <Form.Control
                          type="number"
                          name="motor_amp"
                          placeholder="Enter motor amp"
                          value={offer?.motor_amp || ""}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.motor_amp?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label className="form-view-label">
                          Lift Will Be Run
                        </Form.Label>

                        <FormSelect
                          name="lift_run_phase"
                          value={offer?.lift_run_phase ?? ""}
                          onChange={handleChange}
                        >
                          <option value="">--select phase--</option>
                          <option value="Single Phase">Single Phase</option>
                          <option value="Three Phase">Three Phase</option>
                        </FormSelect>

                        <Form.Control.Feedback type="invalid">
                          {errors?.lift_run_phase?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {/*Imran Khan Added Driven Section */}
                    {/* Rope/Belt Driven Section */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label className="form-view-label">
                          Drive Type
                        </Form.Label>
                        <Form.Select
                          name="drive_type"
                          value={offer?.drive_type ?? ""}
                          onChange={handleChange}
                        >
                          <option value="">--select drive type--</option>
                          <option value="Rope Driven">Rope Driven</option>
                          <option value="Belt Driven">Belt Driven</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors?.drive_type?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {/*Imran Khan Added  Door Opening*/}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label className="form-view-label">
                          Door Opening
                        </Form.Label>

                        <Form.Select
                          value={
                            isSideSelected
                              ? "SIDE"
                              : offer?.door_opening === "CENTER"
                                ? "CENTER"
                                : ""
                          }
                          onChange={(e) => {
                            const val = e.target.value;

                            setOffer((prev) => ({
                              ...prev,
                              door_opening:
                                val === "CENTER" ? "CENTER" : "SIDE",
                            }));
                          }}
                        >
                          <option value="">Select</option>
                          <option value="CENTER">Center Opening</option>
                          <option value="SIDE">Side Door Opening</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    {isSideSelected && (
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label className="form-view-label">
                            Side Opening
                          </Form.Label>

                          {["SIDE_LEFT", "SIDE_RIGHT"].map((opt) => (
                            <Form.Check
                              key={opt}
                              type="checkbox"
                              label={
                                opt === "SIDE_LEFT" ? "Left Side" : "Right Side"
                              }
                              checked={sideValues.includes(opt)}
                              onChange={(e) => {
                                let updated = [...sideValues];

                                if (e.target.checked) {
                                  updated.push(opt);
                                } else {
                                  updated = updated.filter((v) => v !== opt);
                                }

                                setOffer((prev) => ({
                                  ...prev,
                                  door_opening: updated.length
                                    ? updated.join(",")
                                    : "SIDE",
                                }));
                              }}
                            />
                          ))}
                        </Form.Group>
                      </Col>
                    )}
                    {/* Imran Khan Added All Doors Same Dropdown on 29/01/2026 */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label className="form-view-label">
                          All Doors Same
                        </Form.Label>

                        <Form.Select
                          name="all_doors_same"
                          placeholder="Enter all doors same"
                          value={offer?.all_doors_same || ""}
                          onChange={handleChange}
                          isInvalid={!!errors?.all_doors_same}
                        >
                          <option value="">Select</option>
                          <option value="ALL_SAME_SIDE">
                            All Door Same Side
                          </option>
                          <option value="DIFFERENT">
                            Different Door Configuration
                          </option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors?.all_doors_same?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {/* Imran Khan Added Door Configuration Section on 29/01/2026 */}
                    {/* {offer?.all_doors_same === "No" &&
                      offer?.total_stops &&
                      offer?.number_of_openings &&
                      Number(offer.total_stops) !==
                        Number(offer.number_of_openings) && (
                        <>
                          <Col lg={6}>
                            <Form.Group>
                              <Form.Label className="form-view-label">
                                Any Floor Both Side
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="both_side_floor"
                                value={offer?.both_side_floor || ""}
                                onChange={handleChange}
                                placeholder="Enter floor"
                              />
                            </Form.Group>
                          </Col>

                          <Col lg={6}>
                            <Form.Group>
                              <Form.Label className="form-view-label">
                                Reverse Opening Floor
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="reverse_opening_floor"
                                value={offer?.reverse_opening_floor || ""}
                                onChange={handleChange}
                                placeholder="Enter floor"
                              />
                            </Form.Group>
                          </Col>

                          <Col lg={6}>
                            <Form.Group>
                              <Form.Label className="form-view-label">
                                Side Opening Floor
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="side_opening_floor"
                                value={offer?.side_opening_floor || ""}
                                onChange={handleChange}
                                placeholder="Enter floor"
                              />
                            </Form.Group>
                          </Col>
                        </>
                      )} */}

                    {showDoorConfig && (
                      <>
                        <Col lg={6}>
                          <Form.Group>
                            <Form.Label className="form-view-label">
                              Any Floor Both Side
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="both_side_floor"
                              placeholder="Enter floor name"
                              value={offer?.both_side_floor || ""}
                              onChange={handleChange}
                            />
                          </Form.Group>
                        </Col>

                        <Col lg={6}>
                          <Form.Group>
                            <Form.Label className="form-view-label">
                              Reverse Opening Floor
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="reverse_opening_floor"
                              placeholder="Enter floor name"
                              value={offer?.reverse_opening_floor || ""}
                              onChange={handleChange}
                            />
                          </Form.Group>
                        </Col>

                        <Col lg={6}>
                          <Form.Group>
                            <Form.Label className="form-view-label">
                              Side Opening Floor
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="side_opening_floor"
                              placeholder="Enter floor name"
                              value={offer?.side_opening_floor || ""}
                              onChange={handleChange}
                            />
                          </Form.Group>
                        </Col>
                      </>
                    )}
                    {/* ENd here Imran */}
                    {/* Imran Khan Added Door Vision Dropdown on 27/01/2026 */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicDoorVision"
                        >
                          Door Vision
                        </Form.Label>

                        <Form.Select
                          name="door_vision"
                          value={offer?.door_vision ?? ""}
                          onChange={handleChange}
                        >
                          <option value="">--select door vision--</option>
                          <option value="Non Vision">Non Vision</option>
                          <option value="Small Vision">Small Vision</option>
                          <option value="Big Vision">Big Vision</option>
                          <option value="Full Vision">Full Vision</option>
                        </Form.Select>

                        <Form.Control.Feedback type="invalid">
                          {errors?.door_vision?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    {console.log("doorMakeOption == ", doorMakeOption)}
                    {/* Imran Khan Added Door Make Dropdown on 04/02/2026 */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label className="form-view-label">
                          Door Make
                        </Form.Label>

                        <InputGroup>
                          <Select
                            className="w-75"
                            placeholder="Select Door Make"
                            // options={accounts
                            //   ?.filter(acc => acc.type === "Door Make")
                            //   ?.map(acc => ({
                            //     value: acc.id,
                            //     label: acc.name
                            //   }))}
                            options={doorMakeOption}
                            value={
                              offer?.door_make_id
                                ? {
                                    value: offer.door_make_id,
                                    label: doorMakeOption?.find(
                                      (a) => a.value === offer.door_make_id,
                                    )?.label,
                                  }
                                : null
                            }
                            onChange={(e) =>
                              handleChange({
                                target: {
                                  name: "door_make_id",
                                  value: e?.value || "",
                                },
                              })
                            }
                          />

                          <InputGroup.Text className="d-flex justify-content-center align-items-center w-25 p-0 bg-white">
                            <Button
                              variant="link"
                              className="p-0 border-0"
                              onClick={() => {
                                setNewMake({ name: "", type: "Door Make" });
                                setShowMakeModal(true);
                              }}
                            >
                              <i className="fa fa-plus fa-xl text-success" />
                            </Button>
                          </InputGroup.Text>
                        </InputGroup>
                      </Form.Group>
                    </Col>
                    {/*Imran Khan End here 27/01/2026*/}
                    {/* Added 09-02-2026 Available Shaft Size - Dropdown */}
                     <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicAvailableShaftSize"
                        >
                          Available Shaft Size
                        </Form.Label>
                        <Form.Select
                          name="available_shaft_size"
                          value={offer?.available_shaft_size ?? ""}
                          onChange={handleChange}
                        >
                          <option value="">-- select --</option>
                          <option value="Width">Width</option>
                          <option value="Depth">Depth</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors?.available_shaft_size?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    {/* Conditional Fields - Width */}
                    {offer?.available_shaft_size && (
                      <>
                        <Col lg={6}>
                          <Form.Group>
                            <Form.Label
                              className="form-view-label"
                              htmlFor="formBasicShaftWidthMin"
                            >
                              Minimum {offer?.available_shaft_size} (mm)
                            </Form.Label>
                            <Form.Control
                              type="number"
                              name="shaft_min"
                              min={600}
                              max={5000}
                              placeholder="Enter minimum width 600 - 5000 mm"
                              value={offer?.shaft_min || ""}
                              onChange={handleChange}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors?.shaft_min?.message}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>

                        <Col lg={6}>
                          <Form.Group>
                            <Form.Label
                              className="form-view-label"
                              htmlFor="formBasicShaftWidthMax"
                            >
                              Maximum {offer?.available_shaft_size} (mm)
                            </Form.Label>
                            <Form.Control
                              type="number"
                              name="shaft_max"
                              min={600}
                              max={5000}
                              placeholder="Enter maximum width 600 - 5000 mm"
                              value={offer?.shaft_max || ""}
                              onChange={handleChange}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors?.shaft_max?.message}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </>
                    )}

                     <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicAvailableShaftSize"
                        >
                          Available Car Size
                        </Form.Label>
                        <Form.Select
                          name="available_car_size"
                          value={offer?.available_car_size ?? ""}
                          onChange={handleChange}
                        >
                          <option value="">-- select --</option>
                          <option value="Width">Width</option>
                          <option value="Depth">Depth</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors?.available_car_size?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {offer?.available_car_size && (
                      <>
                        <Col lg={6}>
                          <Form.Group>
                            <Form.Label
                              className="form-view-label"
                              htmlFor="formBasicShaftWidthMin"
                            >
                              Minimum {offer?.available_shaft_size} (mm)
                            </Form.Label>
                            <Form.Control
                              type="number"
                              name="car_internal_min"
                              min={650}
                              max={5000}
                              placeholder="Enter minimum width 650 - 5000 mm"
                              value={offer?.car_internal_min || ""}
                              onChange={handleChange}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors?.car_internal_min?.message}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>

                        <Col lg={6}>
                          <Form.Group>
                            <Form.Label
                              className="form-view-label"
                              htmlFor="formBasicShaftWidthMax"
                            >
                              Maximum {offer?.available_car_size} (mm)
                            </Form.Label>
                            <Form.Control
                              type="number"
                              name="car_internal_max"
                              min={650}
                              max={5000}
                              placeholder="Enter maximum width 650 - 5000 mm"
                              value={offer?.car_internal_max || ""}
                              onChange={handleChange}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors?.car_internal_max?.message}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </>
                    )}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicAvailableShaftSize"
                        >
                          Door Size Clear
                        </Form.Label>
                        <Form.Select
                          name="door_size"
                          value={offer?.door_size ?? ""}
                          onChange={handleChange}
                        >
                          <option value="">-- select --</option>
                          <option value="width">Width</option>
                          <option value="height">Height</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors?.door_size?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {offer?.door_size && (
                      <>
                        <Col lg={6}>
                          <Form.Group>
                            <Form.Label
                              className="form-view-label"
                              htmlFor="formBasicShaftWidthMin"
                            >
                              Minimum {offer?.door_size} (mm)
                            </Form.Label>
                            <Form.Control
                              type="number"
                              name="door_min"
                              min={offer?.door_size === "width" ? 600 : "height" ? 2000 : ""}
                              max={offer?.door_size === "width" ? 4000 : "height" ? 3000 : ""}
                              placeholder={offer?.door_size === "width" ? "Enter minimum width 600 - 4000 mm" : "height" ? "Enter minimum height 2000 - 3000 mm" : ""}
                              value={offer?.door_min || ""}
                              onChange={handleChange}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors?.door_min?.message}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>

                        <Col lg={6}>
                          <Form.Group>
                            <Form.Label
                              className="form-view-label"
                              htmlFor="formBasicShaftWidthMax"
                            >
                              Maximum {offer?.door_size} (mm)
                            </Form.Label>
                            <Form.Control
                              type="number"
                              name="door_max"
                              min={offer?.door_size === "width" ? 600 : "height" ? 2000 : ""}
                              max={offer?.door_size === "width" ? 4000 : "height" ? 3000 : ""}
                              placeholder={offer?.door_size === "width" ? "Enter minimum width 600 - 4000 mm" : "height" ? "Enter minimum height 2000 - 3000 mm" : ""}
                              value={offer?.door_max || ""}
                              onChange={handleChange}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors?.door_max?.message}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </>
                    )}

                    {/* Imran Khan Added Operation on 27/01/2026 */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicOperation"
                        >
                          Operation
                        </Form.Label>
                        <Form.Select
                          name="operation"
                          value={offer?.operation || ""}
                          onChange={handleChange}
                        >
                          <option value="">--select operation--</option>
                          <option value="Simplex Full Collective">
                            Simplex Full Collective
                          </option>
                          <option value="Duplex Full Collective">
                            Duplex Full Collective
                          </option>
                          <option value="Triplex Full Collective">
                            Triplex Full Collective
                          </option>
                          <option value="Down Collective">
                            Down Collective
                          </option>
                          {/* Add more options as needed */}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors?.operation?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {/*Imran Khan Added Metal Of Door*/}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicDoorMetal"}
                        >
                          Metal of Door
                        </Form.Label>

                        <Form.Control
                          as="select"
                          name="door_metal"
                          value={offer?.door_metal || ""}
                          onChange={handleChange}
                        >
                          <option value="">--select door metal--</option>
                          <option value="MS">MS</option>
                          <option value="SS">SS</option>
                          <option value="Golden / Rose Gold">
                            Golden / Rose Gold
                          </option>
                        </Form.Control>

                        <Form.Control.Feedback type="invalid">
                          {errors?.door_metal?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {offer?.door_metal && (
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor={"formBasicDoorFinish"}
                          >
                            Finish
                          </Form.Label>

                          <FormSelect
                            name="metal_finish"
                            value={offer?.metal_finish ?? ""}
                            onChange={handleChange}
                          >
                            <option value="">--select finish--</option>

                            {offer.door_metal === "MS" && (
                              <option value="Epoxy RAL">Epoxy RAL</option>
                            )}

                            {(offer.door_metal === "SS" ||
                              offer.door_metal === "Golden / Rose Gold") && (
                              <>
                                <option value="Mirror">Mirror</option>
                                <option value="Hairline">Hairline</option>
                                <option value="Lenin">Lenin</option>
                                <option value="Honey Comb">Honey Comb</option>
                                <option value="Moonrock Finish">
                                  Moonrock Finish
                                </option>
                              </>
                            )}
                          </FormSelect>
                        </Form.Group>
                      </Col>
                    )}
                    {/* End here Imran Khan */}
                    {/* Imran Khan Added Control Panel Make Dropdown on 04/02/2026 */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label className="form-view-label">
                          Control Panel Make
                        </Form.Label>

                        <InputGroup>
                          <Select
                            className="w-75"
                            placeholder="Select Control Panel Make"
                            // options={accounts
                            //   ?.filter(acc => acc.type === "Control Panel Make")
                            //   ?.map(acc => ({
                            //     value: acc.id,
                            //     label: acc.name
                            //   }))}
                            options={controlMakeOption}
                            value={
                              offer?.control_panel_make_id
                                ? {
                                    value: offer.control_panel_make_id,
                                    label: controlMakeOption?.find(
                                      (a) =>
                                        a.value === offer.control_panel_make_id,
                                    )?.label,
                                  }
                                : null
                            }
                            onChange={(e) =>
                              handleChange({
                                target: {
                                  name: "control_panel_make_id",
                                  value: e?.value || "",
                                },
                              })
                            }
                          />

                          <InputGroup.Text className="d-flex justify-content-center align-items-center w-25 p-0 bg-white">
                            <Button
                              variant="link"
                              className="p-0 border-0"
                              onClick={() => {
                                setNewMake({
                                  name: "",
                                  type: "Control Panel Make",
                                });
                                setShowMakeModal(true);
                              }}
                            >
                              <i className="fa fa-plus fa-xl text-success" />
                            </Button>
                          </InputGroup.Text>
                        </InputGroup>
                      </Form.Group>
                    </Col>

                    {/* End here Imran Khan */}

                    {/* Imran Khan Added Lift Technology, Pit and Overhead on 28/01/2026 */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicLiftType"}
                        >
                          Lift Type
                        </Form.Label>

                        <Form.Select
                          name="lift_drive_type"
                          value={offer?.lift_drive_type || ""}
                          onChange={(e) =>
                            handleChange(e, { lift_pit: "", lift_overhead: "" })
                          }
                        >
                          <option value="">--select technology--</option>
                          <option value="Vacuum">Vacuum</option>
                          <option value="Geared">Geared</option>
                          <option value="Gearless">Gearless</option>
                          <option value="Hydraulic">Hydraulic</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    {/* Imran Khan Added Lift Pit on 28/01/2026 */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicLiftPit"}
                        >
                          Lift Pit
                        </Form.Label>

                        <Form.Select
                          name="lift_pit"
                          value={offer?.lift_pit || ""}
                          disabled={!offer?.lift_drive_type}
                          onChange={handleChange}
                        >
                          <option value="">--select pit--</option>

                          {civilRequirements[offer?.lift_drive_type]?.pit.map(
                            (p) =>
                              typeof p === "object" ? (
                                <option key={p.value} value={p.value}>
                                  {p.label}
                                </option>
                              ) : (
                                <option key={p} value={p}>
                                  {p} mm
                                </option>
                              ),
                          )}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    {/* Imran Khan Added Lift Overhead on 28/01/2026 */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicLiftOverhead"}
                        >
                          Lift Overhead
                        </Form.Label>

                        <Form.Select
                          name="lift_overhead"
                          value={offer?.lift_overhead || ""}
                          disabled={!offer?.lift_drive_type}
                          onChange={handleChange}
                        >
                          <option value="">--select overhead--</option>

                          {civilRequirements[
                            offer?.lift_drive_type
                          ]?.overhead.map((o) => (
                            <option key={o} value={o}>
                              {isNaN(o) ? o : `${o} mm`}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    {/* End here Imran Khan */}
                    {/* Imran Khan Added Cabin Wall Material, Cabin Wall Finish, Cabin Ceiling Material, Cabin Ceiling Finish and Cabin Light Type on 28/01/2026 */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicCabinWallMaterial"}
                        >
                          Cabin Wall Material
                        </Form.Label>

                        <Form.Select
                          name="cabin_wall_material"
                          value={offer?.cabin_wall_material || ""}
                          onChange={(e) =>
                            handleChange(e, { cabin_wall_finish: "" })
                          }
                        >
                          <option value="">--select material--</option>
                          <option value="MS">MS</option>
                          <option value="SS">SS</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicCabinWallFinish"}
                        >
                          Cabin Wall Finish
                        </Form.Label>

                        <Form.Select
                          name="cabin_wall_finish"
                          value={offer?.cabin_wall_finish || ""}
                          disabled={!offer?.cabin_wall_material}
                          onChange={handleChange}
                        >
                          <option value="">--select finish--</option>

                          {cabinConfig.wall[offer?.cabin_wall_material]?.map(
                            (f) => (
                              <option key={f} value={f}>
                                {f}
                              </option>
                            ),
                          )}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicCabinCeilingMaterial"}
                        >
                          Cabin Ceiling Material
                        </Form.Label>

                        <Form.Select
                          name="cabin_ceiling_material"
                          value={offer?.cabin_ceiling_material || ""}
                          onChange={(e) =>
                            handleChange(e, { cabin_ceiling_finish: "" })
                          }
                        >
                          <option value="">--select material--</option>
                          <option value="MS">MS</option>
                          <option value="SS">SS</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicCabinCeilingFinish"}
                        >
                          Cabin Ceiling Finish
                        </Form.Label>

                        <Form.Select
                          name="cabin_ceiling_finish"
                          value={offer?.cabin_ceiling_finish || ""}
                          disabled={!offer?.cabin_ceiling_material}
                          onChange={handleChange}
                        >
                          <option value="">--select finish--</option>

                          {cabinConfig.ceiling[
                            offer?.cabin_ceiling_material
                          ]?.map((f) => (
                            <option key={f} value={f}>
                              {f}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicCabinLightType"}
                        >
                          Cabin Light Type
                        </Form.Label>

                        <Form.Select
                          name="cabin_light_type"
                          value={offer?.cabin_light_type || ""}
                          onChange={handleChange}
                        >
                          <option value="">--select light--</option>
                          {cabinConfig.light.map((l) => (
                            <option key={l} value={l}>
                              {l}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    {/* End here Imran Khan */}
                    {/*Imran khan Added Fan */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicFan"}
                        >
                          Fan
                        </Form.Label>
                        <Form.Select
                          name="fan"
                          value={offer?.fan ?? ""}
                          onChange={handleChange}
                        >
                          <option value="">--select fan units--</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                          <option value="6">6</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors?.fan?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicBlower"}
                        >
                          Blower
                        </Form.Label>
                        <Form.Select
                          name="blower"
                          value={offer?.blower ?? ""}
                          onChange={handleChange}
                        >
                          <option value="">--select blower units--</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                          <option value="6">6</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors?.blower?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {/* Imran Khan Added Handrail Shape on 27/01/2026 */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicHandrailShape"}
                        >
                          Handrail Shape
                        </Form.Label>
                        <FormSelect
                          name="handrail_shape"
                          value={offer?.handrail_shape ?? ""}
                          onChange={handleChange}
                        >
                          <option value="">--select shape--</option>
                          <option value="Round">Round</option>
                          <option value="Square">Square</option>
                          <option value="Angle">Angle</option>
                        </FormSelect>

                        <Form.Control.Feedback type="invalid">
                          {errors?.handrail_shape?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {/*Imran Khan Added Handaril Material */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicHandrailMaterial"}
                        >
                          Handrail Material
                        </Form.Label>

                        <Form.Select
                          name="handrail_material"
                          value={offer?.handrail_material || ""}
                          onChange={(e) =>
                            handleChange(e, { handrail_finish: "" })
                          }
                        >
                          <option value="">--select material--</option>
                          <option value="MS">MS</option>
                          <option value="SS">SS</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicHandrailFinish"}
                        >
                          Handrail Finish
                        </Form.Label>

                        <Form.Select
                          name="handrail_finish"
                          value={offer?.handrail_finish || ""}
                          disabled={!offer?.handrail_material}
                          onChange={handleChange}
                        >
                          <option value="">--select finish--</option>

                          {cabinConfig?.handrail?.[
                            offer?.handrail_material || ""
                          ]?.map((f) => (
                            <option key={f} value={f}>
                              {f}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicFlooring"}
                        >
                          Flooring
                        </Form.Label>

                        <Form.Control
                          type="text"
                          name="flooring"
                          placeholder="Enter Flooring"
                          value={offer?.flooring || ""}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.flooring?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {/* End here Imran Khan */}

                    {/* Imran Khan Added Car Operating Panel Dropdowns on 05/02/2026 */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicCopPanelType"}
                        >
                          Panel Type
                        </Form.Label>
                        <Form.Select
                          name="cop_panel_type"
                          value={offer?.cop_panel_type ?? ""}
                          onChange={handleChange}
                          isInvalid={!!errors?.cop_panel_type}
                        >
                          <option value="">-- select panel type --</option>
                          <option value="Flush">Flush</option>
                          <option value="Wall Mount">Wall Mount</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors?.cop_panel_type?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicCopButtonType"}
                        >
                          Button Type
                        </Form.Label>
                        <Form.Select
                          name="cop_button_type"
                          value={offer?.cop_button_type ?? ""}
                          onChange={handleChange}
                          isInvalid={!!errors?.cop_button_type}
                        >
                          <option value="">-- select interface type --</option>
                          <option value="Push Button">Push Button</option>
                          <option value="Touch">Touch</option>
                          <option value="TFT">TFT</option>
                          <option value="LCD">LCD</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors?.cop_button_type?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    {/* Display (Conditional - only for TFT/LCD) */}
                    {(offer?.cop_button_type === "TFT" ||
                      offer?.cop_button_type === "LCD") && (
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor={"formBasicCopDisplayType"}
                          >
                            Display Type
                          </Form.Label>
                          <Form.Select
                            name="cop_display"
                            value={offer?.cop_display ?? ""}
                            onChange={handleChange}
                            isInvalid={!!errors?.cop_display}
                          >
                            <option value="">-- select display --</option>
                            <option value="Floor Number Only">
                              Floor Number Only
                            </option>
                            <option value="Floor Number with Arrows">
                              Floor Number with Up/Down Arrows
                            </option>
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {errors?.cop_display?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    )}
                    {/* End here Imran Khan */}
                    {/* Imran Khan Added Car Operating Panel on 29/01/2026 */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicCopFinish"}
                        >
                          Car Operating Panel Finish
                        </Form.Label>

                        <Form.Select
                          name="cop_finish"
                          value={offer?.cop_finish || ""}
                          onChange={handleChange}
                        >
                          <option value="">--select finish--</option>
                          <option value="SS">SS</option>
                          <option value="RG">RG</option>
                          <option value="Golden">Golden</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicCopBraille"}
                        >
                          Braille
                        </Form.Label>

                        <Form.Select
                          name="cop_braille"
                          value={offer?.cop_braille || ""}
                          onChange={handleChange}
                        >
                          <option value="">--select--</option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label className="form-view-label">
                          Landing Panel Type
                        </Form.Label>
                        <Form.Select
                          name="lop_panel_type"
                          value={offer?.lop_panel_type ?? ""}
                          onChange={handleChange}
                        >
                          <option value="">-- select panel type --</option>
                          <option value="Flush">Flush</option>
                          <option value="Wall Mount">Wall Mount</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label className="form-view-label">
                          Landing Button Type
                        </Form.Label>
                        <Form.Select
                          name="lop_button_type"
                          value={offer?.lop_button_type ?? ""}
                          onChange={handleChange}
                        >
                          <option value="">-- select button type --</option>
                          <option value="Push Button">Push Button</option>
                          <option value="Touch">Touch</option>
                          <option value="TFT">TFT</option>
                          <option value="LCD">LCD</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    {(offer?.lop_button_type === "TFT" ||
                      offer?.lop_button_type === "LCD") && (
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label className="form-view-label">
                            Landing Display Type
                          </Form.Label>
                          <Form.Select
                            name="lop_display"
                            value={offer?.lop_display ?? ""}
                            onChange={handleChange}
                          >
                            <option value="">-- select display --</option>
                            <option value="Floor Number Only">
                              Floor Number Only
                            </option>
                            <option value="Floor Number with Up/Down Arrows">
                              Floor Number with Up & Down Arrows
                            </option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    )}
                    {/* End here Imran Khan */}
                    {/* Imran Khan Added All Landing Operating Panel on 04/02/2026 */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label className="form-view-label">
                          All Landing Operating Panel Finish
                        </Form.Label>

                        <Form.Select
                          name="all_landing_op_finish"
                          value={offer?.all_landing_op_finish || ""}
                          onChange={handleChange}
                        >
                          <option value="">--select finish--</option>
                          <option value="SS">SS</option>
                          <option value="RG">RG</option>
                          <option value="Golden">Golden</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label className="form-view-label">
                          Braille
                        </Form.Label>

                        <Form.Select
                          name="all_landing_op_braille"
                          value={offer?.all_landing_op_braille || ""}
                          onChange={handleChange}
                        >
                          <option value="">--select--</option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    {/* End here Imran Khan */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicNumberOfDoorPanels"}
                        >
                          Door Panels
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="door_panels"
                          placeholder="Enter door panels"
                          value={offer?.door_panels || ""}
                          onChange={handleChange}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.door_panels?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {/* Imran Khan Added Machine Room Dropdown on 28/01/2026 */}
                   <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicMachineRoom"}
                        >
                          Machine Room
                        </Form.Label>

                        <Form.Select
                          name="machine_room"
                          placeholder="Enter machine room"
                          value={offer?.machine_room || ""}
                          onChange={(e) => handleChange(e)}
                        >
                          <option value="">Select</option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors?.machine_room?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {offer?.machine_room === "Yes" && (
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor={"formBasicMachineRoomHeight"}
                          >
                            Machine Room Height (mm)
                          </Form.Label>

                          <Form.Control
                            type="number"
                            name="machine_room_height"
                            value={offer?.machine_room_height || 2000}
                            onChange={(e) => handleChange(e)}
                            min={2000}
                            // required
                          />

                          <Form.Control.Feedback type="invalid">
                            Height must be minimum 2000 mm
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    )}
                    {/* End here Imran Khan */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicDlpPeriod"}
                        >
                          Dlp Period
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="dlp_period"
                          placeholder="Enter dlp period"
                          value={offer?.dlp_period || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.dlp_period?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicBrandOffered"}
                        >
                          Brand Offered
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="brand_offered"
                          placeholder="Enter brand offered"
                          value={offer?.brand_offered || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.brand_offered?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    {/* <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicDoorOpening"}
                        >
                          Door Opening
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="door_opening"
                          placeholder="Enter door opening"
                          value={offer?.door_opening || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.door_opening?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col> */}

                    {/* <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicDoorMetal"}
                        >
                          Door Metal
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="door_metal"
                          placeholder="Enter door metal"
                          value={offer?.door_metal || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.door_metal?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col> */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicCabinMetal"}
                        >
                          Cabin Metal
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="cabin_metal"
                          placeholder="Enter cabin metal"
                          value={offer?.cabin_metal || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.cabin_metal?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {/* <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicDoorVision"}
                        >
                          Door Vision
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="door_vision"
                          placeholder="Enter door vision"
                          value={offer?.door_vision || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.door_vision?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col> */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicShaftConstructionOf"}
                        >
                          Shaft Construction
                        </Form.Label>
                       <Form.Control
                          type="text"
                          name="shaft_construction"
                          placeholder="Enter shaft construction"
                          value={offer?.shaft_construction || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.shaft_construction?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {/* <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicMachineRoom"}
                        >
                          Machine Room
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="machine_room"
                          placeholder="Enter machine room"
                          value={offer?.machine_room || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.machine_room?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col> */}
                   <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicOfferSide"}
                        >
                          Offer Side
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="offer_side"
                          placeholder="Enter offer side"
                          value={offer?.offer_side || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.offer_side?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </>

                  <>
                    <Col lg={12} className="section-header">
                      ADDRESS INFORMATION
                    </Col>
                    <Col lg={6}>
                      <Form.Group
                        className="form-view-label"
                        htmlFor={"formBasicSiteAddress"}
                      >
                        <Form.Label>Site Address</Form.Label>
                        <Form.Control
                          type="text"
                          name="site_address"
                          placeholder="Enter site address"
                          value={offer?.site_address || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.site_address?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {/* Add area fields by shahir hussain 28-01-2026 */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicArea"
                        >
                          Area
                        </Form.Label>
                        <Form.Control
                          pattern={regExPattern.name}
                          type="text"
                          name="area"
                          placeholder="Enter area name"
                          value={offer?.area || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.area?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicState"
                        >
                          State
                        </Form.Label>

                        <Select
                          placeholder="Select your state"
                          classNamePrefix="react-select"
                          options={states?.map((state) => ({
                            value: state,
                            label: state,
                          }))}
                          onChange={(e) => {
                            setOffer((prev) => ({ ...prev, city: "" }));
                            handleChange({
                              target: { name: "state", value: e.value },
                            });
                          }}
                          value={
                            offer?.state
                              ? {
                                value: offer?.state || "",
                                label: offer?.state || "",
                              }
                              : ""
                          }
                        ></Select>
                        <Form.Control.Feedback type="invalid">
                          {errors?.state?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCity"
                        >
                          City
                        </Form.Label>
                        <Form.Control
                          pattern={regExPattern.name}
                          type="text"
                          name="city"
                          placeholder="Enter city name"
                          value={offer?.city || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.city?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group
                        className="form-view-label"
                        htmlFor={"formBasicOfficeAddress"}
                      >
                        <Form.Label>Office Address</Form.Label>
                         <Form.Control
                          type="text"
                          name="office_address"
                          placeholder="Enter office address"
                          value={offer?.office_address || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.office_address?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicOfficeCity"
                        >
                          Office City
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="office_city"
                          placeholder="Enter office city name"
                          value={offer?.office_city || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.office_city?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicPin"
                        >
                          Pincode
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="pincode"
                          placeholder="Enter pincode"
                          value={offer?.pincode || ""}
                          onChange={handleChange}
                          pattern={regExPattern.pinCode}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.pincode?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCountry"
                        >
                          Country
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="country"
                          placeholder="Enter country"
                          value={offer?.country || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                          pattern={regExPattern.name}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.country?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </>

                  <Modal
                    show={showIsLostModal}
                    onHide={handleCloseIsLostModal}
                    backdrop="static"
                    keyboard={false}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>REASON OF LOST LEAD</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Col lg={12}>
                        <Form.Group>
                          <Form.Label>Lost Date</Form.Label>
                          <Form.Control
                            disabled
                            value={formatDateForCreatedDate(
                              offer?.is_lost_date,
                            )}
                          />
                        </Form.Group>
                      </Col>
                      <Col lg={12}>
                        <Form.Group>
                          <Form.Label>Reason</Form.Label>
                          <Form.Control
                            type="text"
                            name="is_lost_remark"
                            placeholder="Enter lost reason"
                            value={offer?.is_lost_remark || ""}
                            onChange={handleChange}
                          />
                        </Form.Group>
                      </Col>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="success"
                        onClick={handleCloseIsLostModal}
                      >
                        Done
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </Row>
              </CardBody>
            </Card>
          </Form>
        </Col>
      </Row>
      <Modal
        show={showMakeModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Create Make
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Container className="view-form">
            <Row>
              <Col lg={12}>
                <Form className="mt-3">
                  {/* NAME */}
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Enter Make Name"
                      value={newMake.name}
                      onChange={handleChangeMake}
                    />
                  </Form.Group>

                  {/* TYPE */}
                  <Form.Group className="mx-3 mt-3">
                    <Form.Label className="form-view-label">Type</Form.Label>
                    <Form.Control type="text" value={newMake.type} disabled />
                  </Form.Group>
                </Form>
              </Col>
            </Row>
          </Container>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="success" onClick={handleSubmitMake}>
            Save
          </Button>
          <Button variant="light" onClick={handleMakeModelClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default OfferEdit;